export enum ComponentTypes {
  Rotable = 1,
  Expandable = 2,
  Tool = 3,
}

export const ComponentTypesChoices = [
  { id: ComponentTypes.Rotable, name: "Rotable" },
  { id: ComponentTypes.Expandable, name: "Expandable" },
  { id: ComponentTypes.Tool, name: "Tool" },
];
